export const isHexColor = (value: string) =>
    /^#[0-9A-F]{6}$/i.test(value)
;